<script setup>
import { useUserStore } from '@/stores/index.js';
import { useStorage } from '@vueuse/core';
import { ElButton, ElDrawer, ElOption, ElSelect } from 'element-plus';
import { ref } from 'vue';

const userStore = useUserStore();
const aliveUserTag = useStorage('aliveUserTag', '');
const allUserTag = ref([
  {
    value: 'LAPTOP-QS4DU2QR',
    name: '李超',
  },
  {
    value: 'LAPTOP-PF3XFM68',
    name: '陈超',
  },
  {
    value: 'LAPTOP-HHCVPGAF',
    name: '王帅',
  },
]);

const aliveProxy = useStorage('aliveProxy', '/dev-api');
const allProxy = ref([
  {
    value: '/dev-api',
    name: '开发环境',
  },
  {
    value: '/test-api',
    name: '测试环境',
  },
  {
    value: '/production-api',
    name: '生产环境',
  },
]);

const showConfig = ref(false);
const userTag = ref(aliveUserTag.value);
const apiProxy = ref(aliveProxy.value);

// 保存配置
function saveConfig() {
  aliveUserTag.value = userTag.value;
  aliveProxy.value = apiProxy.value;
  showConfig.value = false;
  userStore.userInfo = {};
  localStorage.setItem('tb_user_info', {});
  window.location.reload();
}
</script>

<template>
  <div
    class="fixed bottom-[12px] left-[78px] z-999 h-[47px] w-[47px] flex cursor-pointer items-center justify-center rounded-full bg-[#000000] text-[#ffffff] shadow-2xl"
    @click="showConfig = true"
  >
    配置
  </div>

  <ElDrawer v-model="showConfig" title="系统配置" direction="rtl">
    <div class="mb-[12px]">
      请求连接
    </div>
    <ElSelect v-model="userTag" clearable class="!w-full" placeholder="请选择用户">
      <ElOption v-for="item in allUserTag" :key="item.value" :value="item.value" :label="item.name">
        {{ item.name }}
      </ElOption>
    </ElSelect>
    <div class="mb-[12px] mt-[24px]">
      代理环境
    </div>
    <ElSelect v-model="apiProxy" class="!w-full">
      <ElOption v-for="item in allProxy" :key="item.value" :value="item.value" :label="item.name">
        {{ item.name }}
      </ElOption>
    </ElSelect>

    <div class="mt-[24px] text-center">
      <ElButton type="primary" @click="saveConfig">
        保存
      </ElButton>
    </div>
  </ElDrawer>
</template>
